'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var parcelDetailComponent = exports.parcelDetailComponent = {
    template: require('./parcel-detail.html'),
    controllerAs: 'vm',
    bindings: {
        parcelId: '<'
    },
    controller: ["common", "gettextCatalog", "parcelService", "toastr", "Analytics", function parcelDetailController(common, gettextCatalog, parcelService, toastr, Analytics) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.cancel = cancel;
        vm.cancelLine = cancelLine;
        vm.cancelOrder = cancelOrder;
        vm.orderCanBeCancelled = orderCanBeCancelled;
        vm.canCancel = true;

        function init() {
            refreshParcel().then(function () {
                var pageTitle = gettextCatalog.getString('parcel.parcel') + ' ' + vm.parcel.number;
                common.setTitle(pageTitle);
                Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/account/parcels/parcel-detail/' + vm.parcel.id, pageTitle);
            });
        }

        function refreshParcel() {
            return parcelService.get(vm.parcelId).then(function (result) {
                vm.parcel = result;
            });
        }

        function cancelLine(lineId) {
            return cancel([lineId]);
        }

        function cancelOrder() {
            return cancel(vm.parcel.lines.map(function (line) {
                return line.id;
            }));
        }

        function cancel(lineIds) {
            return parcelService.cancel(vm.parcel.type.id, lineIds).then(function () {
                toastr.success(gettextCatalog.getString('parcel.parcelCancelCommandSent'), '', {
                    progressBar: true,
                    timeOut: 3000,
                    extendedTimeOut: 1000,
                    closeButton: true
                });
                refreshParcel();
            }).catch(function () {
                toastr.error(gettextCatalog.getString('parcel.errorSendingCancelCommand'), '', {
                    timeOut: 3000,
                    extendedTimeOut: 1000,
                    closeButton: true
                });
            });
        }

        function orderCanBeCancelled() {
            return !vm.parcel.lines.find(function (line) {
                return line.state.code !== 'CREATED' && line.state.code !== 'REG';
            }) && vm.canCancel;
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/account/parcels/parcel-detail.js
// module id = 886
// module chunks = 0